import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { ThemeService, ThemeMode } from './core/services/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  standalone: false,
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class App {
  protected themeService = inject(ThemeService);
  protected theme = this.themeService.mode;

  setTheme(mode: ThemeMode) {
    this.themeService.setMode(mode);
  }
}
